import { Tag } from "antd"

import {
  PROJECT_STATUSES_MAP,
  PROJECT_STATUSES_OBJ
} from "../../Projects/constants/project-statuses.ts"

interface ProjectStatusSelectorProps {
  status: null | string | number
}

export function ProjectStatusTag({ status }: ProjectStatusSelectorProps) {
  if (!status) return <Tag className="m-0">No status</Tag>

  const getStatusData = () => {
    if (typeof status === "number") return PROJECT_STATUSES_OBJ?.[status]
    return PROJECT_STATUSES_MAP?.[status]
  }

  const statusData = getStatusData()

  return (
    <Tag style={statusData?.style} className="m-0">
      {statusData?.label || "No status"}
    </Tag>
  )
}
